import React from "react";

const AttachmentPreview = ({ attachment, className = "" }) => {
    const getFileType = (mimeType) => {
        if (mimeType?.startsWith("image/")) return "image";
        if (mimeType?.startsWith("video/")) return "video";
        if (mimeType === "application/pdf") return "pdf";
        if (mimeType?.includes("word") || mimeType?.includes("document"))
            return "doc";
        if (mimeType?.includes("excel") || mimeType?.includes("spreadsheet"))
            return "excel";
        if (
            mimeType?.includes("powerpoint") ||
            mimeType?.includes("presentation")
        )
            return "powerpoint";
        return "other";
    };

    const fileType = getFileType(attachment.mimeType);

    const renderPreview = () => {
        switch (fileType) {
            case "image":
                return (
                    <div className="w-full h-[160px] bg-gray-100 rounded-t-lg overflow-hidden">
                        <img
                            src={attachment.signedUrl}
                            alt={attachment.name}
                            className="w-full h-full object-cover"
                        />
                    </div>
                );
            case "video":
                return (
                    <div className="w-full h-[160px] bg-gray-900 rounded-t-lg overflow-hidden flex items-center justify-center">
                        <div className="relative">
                            <svg
                                className="w-16 h-16 text-red-500"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
                                />
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                />
                            </svg>
                            <span className="absolute bottom-[-24px] left-1/2 transform -translate-x-1/2 text-xs text-gray-400">
                                Video File
                            </span>
                        </div>
                    </div>
                );
            case "pdf":
                return (
                    <div className="w-full h-[160px] bg-red-50 rounded-t-lg overflow-hidden flex items-center justify-center">
                        <div className="relative">
                            <svg
                                className="w-16 h-16 text-red-500"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                                />
                            </svg>
                            <span className="absolute bottom-[-24px] left-1/2 transform -translate-x-1/2 text-xs text-gray-400">
                                PDF Document
                            </span>
                        </div>
                    </div>
                );
            case "doc":
                return (
                    <div className="w-full h-[160px] bg-blue-50 rounded-t-lg overflow-hidden flex items-center justify-center">
                        <div className="relative">
                            <svg
                                className="w-16 h-16 text-blue-500"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                />
                            </svg>
                            <span className="absolute bottom-[-24px] left-1/2 transform -translate-x-1/2 text-xs text-gray-400">
                                Word Document
                            </span>
                        </div>
                    </div>
                );
            case "excel":
                return (
                    <div className="w-full h-[160px] bg-green-50 rounded-t-lg overflow-hidden flex items-center justify-center">
                        <div className="relative">
                            <svg
                                className="w-16 h-16 text-green-500"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H6a2 2 0 00-2 2v8a2 2 0 002 2z"
                                />
                            </svg>
                            <span className="absolute bottom-[-24px] left-1/2 transform -translate-x-1/2 text-xs text-gray-400">
                                Excel Spreadsheet
                            </span>
                        </div>
                    </div>
                );
            case "powerpoint":
                return (
                    <div className="w-full h-[160px] bg-orange-50 rounded-t-lg overflow-hidden flex items-center justify-center">
                        <div className="relative">
                            <svg
                                className="w-16 h-16 text-orange-500"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z"
                                />
                            </svg>
                            <span className="absolute bottom-[-24px] left-1/2 transform -translate-x-1/2 text-xs text-gray-400">
                                PowerPoint
                            </span>
                        </div>
                    </div>
                );
            default:
                return (
                    <div className="w-full h-[160px] bg-gray-50 rounded-t-lg overflow-hidden flex items-center justify-center">
                        <div className="relative">
                            <svg
                                className="w-16 h-16 text-gray-400"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                                />
                            </svg>
                            <span className="absolute bottom-[-24px] left-1/2 transform -translate-x-1/2 text-xs text-gray-400">
                                File
                            </span>
                        </div>
                    </div>
                );
        }
    };

    const getFileSize = (bytes) => {
        if (!bytes) return "0 Bytes";
        const k = 1024;
        const sizes = ["Bytes", "KB", "MB", "GB"];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    };

    return (
        <a
            href={attachment.signedUrl}
            target="_blank"
            rel="noopener noreferrer"
            className={`block group w-full bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-md transition-all duration-200 ${className}`}
            style={{ maxWidth: "280px" }}
        >
            <div className="relative">
                {renderPreview()}
                <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-40 transition-all duration-200 rounded-t-lg flex items-end justify-center">
                    <div className="opacity-0 group-hover:opacity-100 transform translate-y-1 group-hover:translate-y-0 transition-all duration-200">
                        <svg
                            className="w-10 h-10 text-white"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                            />
                        </svg>
                    </div>
                </div>
            </div>
            <div className="p-4 border-t border-gray-100">
                <p
                    className="text-sm font-medium text-gray-900 truncate"
                    title={attachment.name}
                >
                    {attachment.name}
                </p>
                <p className="text-xs text-gray-500 mt-1">
                    {getFileSize(attachment.size)}
                </p>
            </div>
        </a>
    );
};

export default AttachmentPreview;
